module.exports = __webpack_public_path__ + "static/media/icon-sortie.90ab0fce.svg";